import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "pages/NotFound";
import Sidebar1 from "components/Sidebar1";
import DelivaryChallanList from "pages/DelivaryChallan/DelivaryChallanList";
import DelivaryChallanAdd from "pages/DelivaryChallan/DelivaryChallanAdd";
import DeliveryChallanEdit from "pages/DelivaryChallan/DeliveryChallanEdit";
import DeliveryChallanItemList from "pages/DeliveryChallanItem/DeliveryChallanItemList";
import DeliveryChallanItemAdd from "pages/DeliveryChallanItem/DeliveryChallanItemAdd";
import DeliveryChallanItemUpdate from "pages/DeliveryChallanItem/DeliveryChallanItemUpdate";
import DeliveryChallanEwayBill from "pages/DeliveryChallanEwaybill/DeliveryChallanEwayBill";
import DeliveryChallanInwardAdd from "pages/StockTrasaction/DeliveryChallanInward/DeliveryChallanInwardAdd";

import AddTaxInvoiceForDeliveryChallan from "pages/TaxInvoiceForDeliveryChallan/AddTaxInvoiceForDeliveryChallan";
import AddTaxInvoiceItemsForDeliveryChallan from "pages/TaxInvoiceForDeliveryChallan/AddTaxInvoiceItemsForDeliveryChallan";

import DeliveryChallanInwardTransactionList from "pages/StockTrasaction/DeliveryChallanInward/DeliveryChallanInwardTransactionList";
import DeliveyChallanInwardAll from "pages/StockTrasaction/DeliveryChallanInward/DeliveyChallanInwardAll";
import CancelTaxInvoice from "pages/TaxInvoice/CancelTaxInvoice";

import TaxInvoiceCancelList from "pages/TaxInvoice/TaxInvoiceCancelList";

import TaxInvoiceAddNew from "pages/TaxInvoice/TaxInvoiceAddNew";
import CancelIRNInvoice from "pages/TaxInvoice/CancelIRNInvoice";
import SalesOrderDeliveryChallanItemAdd from "pages/SalesOrder/SalesOrderDeliveryChallanItemAdd";
import Dashboardtest from "pages/DashBoardTest/Dashboardtest";
import DashBoardTestAll from "pages/DashBoardTest/DashBoardTestAll";
import SalesOrderDeliveryChallanItemEdit from "pages/SalesOrderItems/SalesOrderDeliveryChallanItemEdit";
import DashbordItemWiseRevenueReport from "pages/DashBoardTest/DashbordItemWiseRevenueReport";
import TaxInvoiceAgaistSalesOrderReport from "pages/DashboardNew/SalesOrderReport/TaxInvoiceAgaistSalesOrderReport";
import DeliveryChallanEwayBillCancel from "pages/DeliveryChallanEwaybill/DeliveryChallanEwayBillCancel";
import WaitingforInwardAdd from "pages/StockTrasaction/Waiting for Inward/WaitingforInwardAdd";
import DashBoardSupplierReportAll from "pages/DashBoardTest/DashBoardSupplierReports/DashBoardSupplierReportAll";
import ItemWiseSupplierReport from "pages/DashBoardTest/DashBoardSupplierReports/ItemWiseSupplierReport";
import CategoryWiseSupplierSalesReport from "pages/DashBoardTest/DashBoardSupplierReports/CategoryWiseSupplierSalesReport";
import DashBoardNewTest from "pages/DashBoardTest/DashBoardNewTest";
import EwayBillLoginList from "pages/EwayBill/EwayBillLoginList";
import OperationTab from "pages/Operation/OperationTab";
import WorkStationOperationAdd from "pages/WorkStationOperation.jsx/WorkStationOperationAdd";
import CreditNoteItemsAdd from "pages/CreditDebitNote/CreditNote/CreditNoteItems/CreditNoteItemsAdd";
import CreditNoteItemList from "pages/CreditDebitNote/CreditNote/CreditNoteItems/CreditNoteItemList";
import DebitNoteAdd from "pages/CreditDebitNote/DebitNote/DebitNoteAdd";
import DebitNoteItemList from "pages/CreditDebitNote/DebitNote/DebitNoteItems/DebitNoteItemList";
import DebitNoteItemsAdd from "pages/CreditDebitNote/DebitNote/DebitNoteItems/DebitNoteItemsAdd";
import CreditNoteCancel from "pages/CreditDebitNote/CreditNote/CreditNoteCancel";
import DebitNoteTab from "pages/CreditDebitNote/DebitNoteTab";
import QualityTopTab from "pages/Quality/QualityTopTab";
import CompanyLedgerAdd from "pages/CompanySettings/CompanyLedger/CompanyLedgerAdd";
import CompanyLedgerEdit from "pages/CompanySettings/CompanyLedger/CompanyLedgerEdit";
import CompanyAddressAdd from "pages/CompanySettings/CompanyAddresses/CompanyAddressAdd";
import CompanyAddressEdit from "pages/CompanySettings/CompanyAddresses/CompanyAddressEdit";
import JobWorkInwardtoStore from "pages/StockTrasaction/Job Work/JobWorkInwardtoStore";
import WaitingForInwardJobWork from "pages/StockTrasaction/Waiting for Inward/WaitingForInwardJobWork";
import DeliveryChallanItemJobWork from "pages/DeliveryChallanItem/DeliveryChallanItemJobWork";
import JobWorkReports from "pages/DashBoardTest/JObWorkReport/JobWorkReports";
import FinCompanyPurchaseOrderList from "financial/pages/FinCompanyPurchaseOrderInvoice/FinCompanyPurchaseOrderList";
import FinCompanyPurchaseOrderInvoiceAddModal from "financial/pages/FinCompanyPurchaseOrderInvoice/FinCompanyPOinvoiceAddforNonGRN/FinCompanyPurchaseOrderInvoiceAddModal";
import JobCardAddNew from "pages/JobCard/JobCardAddNew/JobCardAddNew";
import JobCardProductionRejectionDeailsTopTab from "pages/JobCardProductionRejectionDetail/JobCardProductionRejectionDeailsTopTab";

const GatePassTopTab = React.lazy(() =>
  import("pages/GatePassEntry/GatePassTopTab")
);
const CreditDebitNoteAll = React.lazy(() =>
  import("pages/CreditDebitNote/CreditDebitNoteAll")
);
const CreditNoteAdd = React.lazy(() =>
  import("pages/CreditDebitNote/CreditNote/CreditNoteAdd")
);

const AddLedger = React.lazy(() =>
  import("financial/pages/ChartOfAccount/AddLedger")
);
const AddDepartment = React.lazy(() =>
  import("financial/pages/FinancialDepartment/AddDepartment")
);
const EditDepartment = React.lazy(() =>
  import("financial/pages/FinancialDepartment/EditDepartment")
);
const CompanyDepartment = React.lazy(() =>
  import("financial/pages/FinancialDepartment/index")
);

const ProfitCenter = React.lazy(() =>
  import("financial/pages/ProfitCenter/index")
);

const AddProfitCenter = React.lazy(() =>
  import("financial/pages/ProfitCenter/AddProfitCenter")
);
const EditProfitCenter = React.lazy(() =>
  import("financial/pages/ProfitCenter/EditProfitCenter")
);

const CostCenter = React.lazy(() => import("financial/pages/CostCenter/index"));

const EditLedger = React.lazy(() =>
  import("financial/pages/ChartOfAccount/EditLedger")
);
const CompanyLedgers = React.lazy(() =>
  import("financial/pages/CompanyLedgers")
);
const BomMasterRoutingList = React.lazy(() =>
  import("pages/BomMasterRouting/BomMasterRoutingList")
);
const BomMasterRoutingAdd = React.lazy(() =>
  import("pages/BomMasterRouting/BomMasterRoutingAdd")
);
const BomMasterRoutingUpdate = React.lazy(() =>
  import("pages/BomMasterRouting/BomMasterRoutingUpdate")
);
const RoutingDetailListByRouting = React.lazy(() =>
  import("pages/RoutingDetail/RoutingDetailListByRouting")
);
const RoutingDetailList = React.lazy(() =>
  import("pages/RoutingDetail/RoutingDetailList")
);
const RoutingDetailAdd = React.lazy(() =>
  import("pages/RoutingDetail/RoutingDetailAdd")
);
const RoutingDetailUpdate = React.lazy(() =>
  import("pages/RoutingDetail/RoutingDetailUpdate")
);
const RoutingAdd = React.lazy(() => import("pages/Routing/RoutingAdd"));
const RoutingUpdate = React.lazy(() => import("pages/Routing/RoutingUpdate"));
const RoutingList = React.lazy(() => import("pages/Routing/RoutingList"));
const Home = React.lazy(() => import("pages/Home"));
const CustomerList2 = React.lazy(() => import("pages/Customer/CustomerList2"));
const CustomertContactList = React.lazy(() =>
  import("pages/CustomerContact/CustomertContactList")
);
const SubContractorContactList = React.lazy(() =>
  import("pages/SubContractorContact/SubContractorContactList")
);
const UpDateSubContact = React.lazy(() =>
  import("pages/SubContractorContact/UpDateSubContact")
);
const Customer = React.lazy(() => import("pages/Customer/Customer"));
const CustomerAdd = React.lazy(() => import("pages/Customer/CustomerAdd"));
const CompanyUserList = React.lazy(() => import("pages/CompayUSerList"));
const UpdateUser = React.lazy(() => import("pages/UpdateUser/UpdateUser"));
const CompanyUser = React.lazy(() => import("pages/CompanyUser"));
const CompanyUserAdd = React.lazy(() =>
  import("pages/CompayUSerList/CompanyUserAdd")
);
const SubContractorContact = React.lazy(() =>
  import("pages/SubContractorContact")
);
const SubContractorContactAdd = React.lazy(() =>
  import("pages/SubContractorContact/SubcontractorAdd")
);
const CustomerUpdate = React.lazy(() =>
  import("pages/Customer/CustomerUpdate")
);
const CustomerContactAdd = React.lazy(() =>
  import("pages/CustomerContact/CustomerAdd")
);
const UpdateCustomerContactList = React.lazy(() =>
  import("pages/UpdateCustomerContactList/UpdateCustomerContactList")
);
const UpdateSubcontractorContact = React.lazy(() =>
  import("pages/UpdateSubcontractorContact/UpdateSubcontractorContact")
);
const Logout = React.lazy(() => import("pages/LogOut/Logout"));
const SubContractorUpdate = React.lazy(() =>
  import("pages/SubcontractorUpdate/SubContractorUpdate")
);
//supplier
const SupplierList = React.lazy(() =>
  import("pages/SupplierList/SupplierList")
);
const SupplierAdd = React.lazy(() => import("pages/SupplierList/SupplierAdd"));
const SupplierUpdate = React.lazy(() =>
  import("pages/SupplierList/SupplierUpdate")
);
//Supplier Contact
const SupplierContactList = React.lazy(() =>
  import("pages/SupplierContactList/SupplierContactList")
);
const SupplierContactAdd = React.lazy(() =>
  import("pages/SupplierContactList/SupplierAdd")
);
const UpdateSupplierContactList = React.lazy(() =>
  import("pages/UpdateSupplierContactList/UpdateSupplierContactList")
);
const ItemTaxList = React.lazy(() => import("pages/ItemTaxList/ItemTaxList"));
const UpdateItemTaxList = React.lazy(() =>
  import("pages/ItemTaxList/UpdateItemTaxList")
);
const ItemSupplierList = React.lazy(() =>
  import("pages/ItemSupplier/ItemSupplierList")
);
const ItemSupplierAdd = React.lazy(() =>
  import("pages/ItemSupplier/ItemSupplierAdd")
);
const ItemSupplierUpdate = React.lazy(() =>
  import("pages/ItemSupplier/ItemSupplierUpdate")
);
const OperationList = React.lazy(() => import("pages/Operation/OperationList"));
const OperatonAdd = React.lazy(() => import("pages/Operation/OperatonAdd"));
const OperationUpdate = React.lazy(() =>
  import("pages/Operation/OperationUpdate")
);
const OperationWorkstationList = React.lazy(() =>
  import("pages/OperationWorkstation/OperationWorkstationList")
);
const OperationWorkstationAdd = React.lazy(() =>
  import("pages/OperationWorkstation/OperationWorkstationAdd")
);
const OperationWorkstationUpdate = React.lazy(() =>
  import("pages/OperationWorkstation/OperationWorkstationUpdate")
);
const WorkStationHourAddList = React.lazy(() =>
  import("pages/WorkStationHours/WorkStationHourAddList")
);
const UpdateWorkStationHours = React.lazy(() =>
  import("pages/WorkStationHours/UpdateWorkStationHours")
);
const WorkStationHourAdd = React.lazy(() =>
  import("pages/WorkStationHours/WorkstationAdd2")
);
const NewItemDetailThree = React.lazy(() => import("pages/NewItemDetailThree"));
const NewItemDetailOne = React.lazy(() => import("pages/NewItemDetailOne"));
const NewItemDetail = React.lazy(() => import("pages/NewItemDetail"));
const NewItemDetailTwo = React.lazy(() => import("pages/NewItemDetailTwo"));
const Item = React.lazy(() => import("pages/Item"));
const EditItem = React.lazy(() => import("pages/Item/EditItem"));
const AddItem = React.lazy(() => import("pages/Item/ItemAdd"));
const ItemInventory = React.lazy(() =>
  import("pages/ItemInventory/ItemInventory")
);
const AddItemToInventory = React.lazy(() =>
  import("pages/ItemInventory/AddItemToInventory")
);
const UpdateItemInventory = React.lazy(() =>
  import("pages/ItemInventory/UpdateItemInventory")
);
const LogInEmptyTwo = React.lazy(() => import("pages/LogInEmptyTwo"));
const LoginPageWrapper = React.lazy(() =>
  import("pages/LogInEmpty/LoginPageWrapper")
);
const LogInEmptyOne = React.lazy(() => import("pages/LogInEmptyOne"));
const LogInEmpty = React.lazy(() => import("pages/LogInEmpty"));
const Subcontractor = React.lazy(() =>
  import("pages/SubContractor/SubContractor")
);
const SubcontractorAdd = React.lazy(() =>
  import("pages/SubContractor/SubcontractorAdd")
);
const CustomerContact = React.lazy(() => import("pages/CustomerContact/index"));
const SubContractorList = React.lazy(() =>
  import("pages/SubContractor/SubcontractList")
);
const ItemListViewPage = React.lazy(() => import("pages/ItemListView/index"));
const ItemQualityList = React.lazy(() =>
  import("pages/ItemQuatlity/ItemQualityList")
);
const ItemQualityAdd = React.lazy(() =>
  import("pages/ItemQuatlity/ItemQalityAdd")
);
const UpdateItemQuality = React.lazy(() =>
  import("pages/ItemQuatlity/UpdateItemQuality")
);
const WorkstationTypeList = React.lazy(() =>
  import("pages/WorkStationType/WorkstationTypeList")
);
const WorkstationTypeAdd = React.lazy(() =>
  import("pages/WorkStationType/WorkstationTypeAdd")
);
const UpdateWorkStationType = React.lazy(() =>
  import("pages/WorkStationType/UpdateWorkStationType")
);
const WorkStationList = React.lazy(() =>
  import("pages/WorkStation/WorkStationList")
);
const WorkStationAdd = React.lazy(() =>
  import("pages/WorkStation/WorkStationAdd")
);
const UpdateWorkStation = React.lazy(() =>
  import("pages/WorkStation/UpdateWorkStation")
);
//sales Order
const SalesOrderList = React.lazy(() =>
  import("pages/SalesOrder/SalesOrderList")
);
const SalesOrderAdd = React.lazy(() =>
  import("pages/SalesOrder/SalesOrderAdd")
);
const SalesOrderEdit = React.lazy(() =>
  import("pages/SalesOrder/SalesOrderEdit")
);
//sales order items
const SalesOrderItemsList = React.lazy(() =>
  import("pages/SalesOrderItems/SalesOrderItemsList")
);
const SalesOrderItemsAdd = React.lazy(() =>
  import("pages/SalesOrderItems/SalesOrderItemsAdd")
);
const SalesOrderItemsEdit = React.lazy(() =>
  import("pages/SalesOrderItems/SalesOrderItemsEdit")
);
//Purchase Order
const PurchaseOrderList = React.lazy(() =>
  import("pages/PurchaseOrder/PurchaseOrderList")
);
const PurchaseOrderAdd = React.lazy(() =>
  import("pages/PurchaseOrder/PurchaseOrderAdd")
);
const PurchaseOrderUpdate = React.lazy(() =>
  import("pages/PurchaseOrder/PurchaseOrderUpdate")
);
const ViewDocs = React.lazy(() => import("pages/PurchaseOrder/ViewDocs"));
//qualityinspectiontemplatelist
const QualityInspectionTemplateList = React.lazy(() =>
  import("pages/QualityInspectionTemplate/QualityInspectionTemplateList")
);
const QualityInspectionTemplateAdd = React.lazy(() =>
  import("pages/QualityInspectionTemplate/QualityInspectionTemplateAdd")
);
const QualityInspectionTemplateUpdate = React.lazy(() =>
  import("pages/QualityInspectionTemplate/QualityInspectionTemplateUpdate")
);
//WareHouse
const WareHouseList = React.lazy(() => import("pages/WareHouse/WareHouseList"));
const WareHouseAdd = React.lazy(() => import("pages/WareHouse/WarehouseAdd"));
const WareHouseUpdate = React.lazy(() =>
  import("pages/WareHouse/WareHouseUpdate")
);
const WareHouseAll = React.lazy(() => import("pages/WareHouse/WareHouseAll"));
// StockTransaction
const StocktransactionAll = React.lazy(() =>
  import("pages/StockTrasaction/StockTransactionAll")
);
const StockPurchaseAdd = React.lazy(() =>
  import("pages/StockTrasaction/Purchase/StockPurchaseAdd")
);
const PurchaseAll = React.lazy(() =>
  import("pages/StockTrasaction/Purchase/PurchaseAll")
);
const JobWorkInwardAll = React.lazy(() =>
  import("pages/StockTrasaction/Job Work/JobWorkInwardAll")
);
const StockPurchaseUpdate = React.lazy(() =>
  import("pages/StockTrasaction/Purchase/StockPurchaseUpdate")
);
const SalesAll = React.lazy(() =>
  import("pages/StockTrasaction/Sales/SalesAll")
);
// ItemCustomer
const ItemCustomerList = React.lazy(() =>
  import("pages/ItemCustomer/ItemCustomerList")
);
const ItemCustomerAdd = React.lazy(() =>
  import("pages/ItemCustomer/ItemCustomerAdd")
);
const ItemCustomerEdit = React.lazy(() =>
  import("pages/ItemCustomer/ItemCustomerEdit")
);
const LoginEwayBill = React.lazy(() => import("pages/EwayBill/LoginEwayBill"));
const TransporterAdd = React.lazy(() =>
  import("pages/Transporter/TransporterAdd")
);
const TransporterList = React.lazy(() =>
  import("pages/Transporter/TransporterList")
);
const TransporterEdit = React.lazy(() =>
  import("pages/Transporter/TransporterEdit")
);
const TransporterDetailsAll = React.lazy(() =>
  import("pages/TransporterDetailsAll/TransporterDetailsAll")
);
const TransporterBankAccountsAdd = React.lazy(() =>
  import("pages/TransporterBankAccounts/TransporterBankAccountsAdd")
);
const TransporterBankAccountsEdit = React.lazy(() =>
  import("pages/TransporterBankAccounts/TransporterBankAccountsEdit")
);
const EwayBillGenerate = React.lazy(() =>
  import("pages/EwayBill/EwayBillGenerate")
);
//Bom
const BomList = React.lazy(() => import("pages/BOM/BomList"));
const BomAdd = React.lazy(() => import("pages/BOM/BomAdd"));
const BomUpdate = React.lazy(() => import("pages/BOM/BomUpdate"));
const BomRawMaterialList = React.lazy(() =>
  import("pages/BomRawMaterial.js/BomRawMaterialList")
);
const BomRawMaterialAdd = React.lazy(() =>
  import("pages/BomRawMaterial.js/BomRawMaterialAdd")
);
const BomRawMaterialUpdate = React.lazy(() =>
  import("pages/BomRawMaterial.js/BomRawMaterialUpdate")
);
const ItmTaxAdd = React.lazy(() => import("pages/ItemTaxList/ItmTaxAdd"));
const BomRawMaterialListByBom = React.lazy(() =>
  import("pages/BomRawMaterial.js/BomRawMaterialListByBom")
);
const BomScrapMaterialList = React.lazy(() =>
  import("pages/BomScrapMaterial/BomScrapMaterialList")
);
const BomScrapMaterialAdd = React.lazy(() =>
  import("pages/BomScrapMaterial/BomScrapMaterialAdd")
);
const BomScrapMaterialEdit = React.lazy(() =>
  import("pages/BomScrapMaterial/BomScrapMaterialEdit")
);
const IndividualItem = React.lazy(() => import("pages/Item/IndividualItem"));
const CustomerDetails = React.lazy(() =>
  import("pages/CustomerDetail/CustomerDetails")
);
const CustomerAddressList = React.lazy(() =>
  import("pages/CustomerAddress/CustomerAddressList")
);
const CustomerAddressAdd = React.lazy(() =>
  import("pages/CustomerAddress/CustomerAddressAdd")
);
const CustomerAddressupdate = React.lazy(() =>
  import("pages/CustomerAddress/CustomerAddressUpdate")
);
const CustomerBankAccountList = React.lazy(() =>
  import("pages/CustomerBankAccount/CustomerBankAccountList")
);
const CustomerBankAccountAdd = React.lazy(() =>
  import("pages/CustomerBankAccount/CustomerBankAccountAdd")
);
const CustomerBankAccountUpdate = React.lazy(() =>
  import("pages/CustomerBankAccount/CustomerBankAccountUpdate")
);
const SalesOrederItemBySalesOrder = React.lazy(() =>
  import("pages/SalesOrderItems/SalesOrederItemBySalesOrder")
);
const SalesOrderAll = React.lazy(() =>
  import("pages/SalesOrder/SalesOrderAll")
);
const TaxInvoiceList = React.lazy(() =>
  import("pages/TaxInvoice/TaxInvoiceList")
);
const TaxInvoiceAdd = React.lazy(() =>
  import("pages/TaxInvoice/TaxInvoiceAdd")
);
const TaxInvoiceUpdate = React.lazy(() =>
  import("pages/TaxInvoice/TaxInvoiceUpdate")
);
const SalesOrderOtherDetailsList = React.lazy(() =>
  import("pages/SalesOrderOtherDetails/SalesOrderOtherDetailsList")
);
const SalesOrderOtherDatailsAdd = React.lazy(() =>
  import("pages/SalesOrderOtherDetails/SalesOrderOtherDatailsAdd")
);
const TaxInvoiceItemList = React.lazy(() =>
  import("pages/TaxInvoiceItem/TaxInvoiceItemList")
);
const TaxInvoiceItemAdd = React.lazy(() =>
  import("pages/TaxInvoiceItem/TaxInvoiceItemAdd")
);
const TaxInvoiceItemUpdate = React.lazy(() =>
  import("pages/TaxInvoiceItem/TaxInvoiceItemUpdate")
);
const SalesOrderOtherDetailsEdit = React.lazy(() =>
  import("pages/SalesOrderOtherDetails/SalesOrderOtherDetailsEdit")
);
const TaxInvoiceItemAddM = React.lazy(() =>
  import("pages/TaxInvoiceItem/TaxInvoiceItemAddM")
);
const InvoicePdf = React.lazy(() => import("pages/InvoicePdf/InvoicePdf"));
const WorkOrder = React.lazy(() => import("pages/WorkOrder/WorkOrder"));
const AddWorkOrder = React.lazy(() => import("pages/WorkOrder/AddWorkOrder"));
const SalesOrderOtherDetailsEdit1 = React.lazy(() =>
  import("pages/SalesOrderOtherDetails/SalesOrderOtherDetailsEdit1")
);
const UpdateWorkOrder = React.lazy(() =>
  import("pages/WorkOrder/UpdateWorkOrder")
);
const WorkStationIndivisual = React.lazy(() =>
  import("pages/WorkStation/WorkStationIndivisual")
);
const BomAll = React.lazy(() => import("pages/BOM/BomAll"));
const SubcontractorDetails = React.lazy(() =>
  import("pages/SubContractorDetails.jsx/SubcontractorDetails")
);
const SubcontractorBankAccountAdd = React.lazy(() =>
  import("pages/SubcontractorBankAccount.jsx/SubcontractorBankAccountAdd")
);
const UpdateSubcontractorBankAccount = React.lazy(() =>
  import("pages/SubcontractorBankAccount.jsx/UpdateSubcontractorBankAccount")
);
const SupplierAll = React.lazy(() => import("pages/SupplierList/SupplierAll"));
const SupplierBankAccountAdd = React.lazy(() =>
  import("pages/SupplierBankAccount/SupplierBankAccountAdd")
);
const SupplierBankAccountEdit = React.lazy(() =>
  import("pages/SupplierBankAccount/SupplierBankAccountEdit")
);
const CompanyPurchesOrderList = React.lazy(() =>
  import("pages/CompanyPurchesOrder/CompanyPurchesOrderList")
);
const CompanyPurchesOrderAdd = React.lazy(() =>
  import("pages/CompanyPurchesOrder/CompanyPurchesOrderAdd")
);
const CompanyPurchaseOrderEdit = React.lazy(() =>
  import("pages/CompanyPurchesOrder/CompanyPurchaseOrderEdit")
);
const CompanyPurchaseOrderAll = React.lazy(() =>
  import("pages/CompanyPurchesOrder/CompanyPurchaseOrderAll")
);
const CompanyPurchaseOrderitemList = React.lazy(() =>
  import("pages/CompanyPurchaseOrderItem/CompanyPurchaseOrderitemList")
);
const CompanyPurchaseOrderItemAdd = React.lazy(() =>
  import("pages/CompanyPurchaseOrderItem/CompanyPurchaseOrderItemAdd")
);
const CompanyPurchaseOrderItemEdit = React.lazy(() =>
  import("pages/CompanyPurchaseOrderItem/CompanyPurchaseOrderItemEdit")
);
const WorkOrderMaintainAll = React.lazy(() =>
  import("pages/StockTrasaction/WorkOrderMaintain/WorkOrderMaintainAll")
);
const WorkOrderGenerateRequest = React.lazy(() =>
  import("pages/WorkOrder/WorkOrderGenerateRequest")
);
const WorkOrderMaterialRequestAll = React.lazy(() =>
  import("pages/WorkOrder/WorkOrderMaterialRequestAll")
);
const TaxInvoiceAddMultiple = React.lazy(() =>
  import("pages/TaxInvoiceItem/TaxInvoiceAddMultiple")
);
const WorkOrderMaterialTransactionHistory = React.lazy(() =>
  import("pages/WorkOrder/WorkOrderRequest/WorkOrderMaterialTransactionHistory")
);
const WorkOrderItems = React.lazy(() =>
  import("pages/WorkOrder/WorkOrderRequest/WorkOrderItems")
);
const WorkOrderMaintainIssueAdd = React.lazy(() =>
  import("pages/StockTrasaction/WorkOrderMaintain/WorkOrderMaintainIssueAdd")
);
const DashBoard = React.lazy(() => import("pages/DashBoard/DashBoard"));
const AdjustmentAdd = React.lazy(() =>
  import("pages/StockTrasaction/Adjustment/AdjustmentAdd")
);
const CompanyUserAccess = React.lazy(() =>
  import("pages/CompayUSerList/CompanyUserAccess")
);
const UpdateUserAccess = React.lazy(() =>
  import("pages/CompayUSerList/UpdateUserAccess")
);
const JobCardList = React.lazy(() => import("pages/JobCard/JobCardList"));
const JobCardAll = React.lazy(() => import("pages/JobCard/JobCardAll"));
const CompanySettingsAll = React.lazy(() =>
  import("pages/CompanySettings/CompanySettingsAll")
);
const CompanyBankAccountList = React.lazy(() =>
  import("pages/CompanySettings/CompanyBankAccountList")
);
const CompanyBankAccountAdd = React.lazy(() =>
  import("pages/CompanySettings/CompanyBankAccountAdd")
);
const CompanyBankAccountEdit = React.lazy(() =>
  import("pages/CompanySettings/CompanyBankAccountEdit")
);
const ManufactureAll = React.lazy(() =>
  import("pages/StockTrasaction/Manufacture/ManufactureAll")
);
const ManufactureAdd = React.lazy(() =>
  import("pages/StockTrasaction/Manufacture/ManufactureAdd")
);
const JobCardUpdate = React.lazy(() => import("pages/JobCard/JobCardUpdate"));
const JobCardWork = React.lazy(() =>
  import("pages/JobCard/JobCardWork/JobCardWork")
);
const JobCardWorkCreate = React.lazy(() =>
  import("pages/JobCard/JobCardWork/JobCardWorkCreate")
);
const HsnSacAll = React.lazy(() =>
  import("pages/HsnSacCodeManagement/HsnSacAll")
);
const HsnCreate = React.lazy(() =>
  import("pages/HsnSacCodeManagement/HSN/HsnCreate")
);
const SacCreate = React.lazy(() =>
  import("pages/HsnSacCodeManagement/SAC/SacCreate")
);
const HsnUpdate = React.lazy(() =>
  import("pages/HsnSacCodeManagement/HSN/HsnUpdate")
);
const SacUpdate = React.lazy(() =>
  import("pages/HsnSacCodeManagement/SAC/SacUpdate")
);
const CapacityPlanList = React.lazy(() =>
  import("pages/CapacityPlan/CapacityPlanList")
);
const CapacityPlanAdd = React.lazy(() =>
  import("pages/CapacityPlan/CapacityPlanAdd")
);
const UpdateCapacityPlan = React.lazy(() =>
  import("pages/CapacityPlan/UpdateCapacityPlan")
);
const IndividualCapacityPlan = React.lazy(() =>
  import("pages/CapacityPlan/IndividualCapacityPlan")
);
const CompanyPurchaseOrderItemRevise = React.lazy(() =>
  import("pages/CompanyPurchaseOrderItem/CompanyPurchaseOrderItemRevise")
);
const CapavityPlanItemAdd = React.lazy(() =>
  import("pages/CapacityPlanItem/CapavityPlanItemAdd")
);
const CapacityItemUpdate = React.lazy(() =>
  import("pages/CapacityPlanItem/CapacityItemUpdate")
);
const DashBoardAll = React.lazy(() => import("pages/DashBoard/DashBoardAll"));
const DashBoardItems = React.lazy(() =>
  import("pages/DashBoard/DashBoardItems")
);
const SupplierPoAll = React.lazy(() =>
  import("pages/DashboardNew/SupplierPo/SupplierPoAll")
);
const SalesOrderReportAll = React.lazy(() =>
  import("pages/DashboardNew/SalesOrderReport/SalesOrderReportAll")
);
const JobCardReportAll = React.lazy(() =>
  import("pages/DashboardNew/JobCardReports/JobCardReportAll")
);
const ItemInventoryReportAll = React.lazy(() =>
  import("pages/DashboardNew/ItemInventoryReports/ItemInventoryReportAll")
);
const UpdateUserAcessAll = React.lazy(() =>
  import("pages/CompayUSerList/UpdateUserAcessAll")
);
const OTPForm = React.lazy(() => import("pages/LogInEmpty/OTPForm"));
const PasswordResetForm = React.lazy(() =>
  import("pages/LogInEmpty/PasswordResetForm")
);
const ItemAllInformationAdd = React.lazy(() =>
  import("pages/Item/ItemAllInformationAdd")
);
const SupplierAllInfoAdd = React.lazy(() =>
  import("pages/SupplierList/SupplierAllInfoAdd")
);
const ItemMultipleAdd = React.lazy(() => import("pages/Item/ItemMultipleAdd"));
const JobCardIndividual = React.lazy(() =>
  import("pages/JobCard/JobCardIndividual")
);
const CreateJobCardProduction = React.lazy(() =>
  import("pages/JobCard/JobCardProduction/CreateJobCardProduction")
);
const CreateJobCardDowntime = React.lazy(() =>
  import("pages/JobCard/JobCardDownTime/CreateJobCardDowntime")
);
const JobCardProductionUpdate = React.lazy(() =>
  import("pages/JobCard/JobCardProduction/JobCardProductionUpdate")
);
const CompanyPurchaseOrderRejectedItemsEdit = React.lazy(() =>
  import(
    "pages/CompanyPurchaseOrderRejectedItems/CompanyPurchaseOrderRejectedItemsEdit"
  )
);
const TaxInvoicePDIRequestList = React.lazy(() =>
  import("pages/TaxInvoicePDI/TaxInvoicePDIRequestList")
);
const TaxInvoicePDIRequestEdit = React.lazy(() =>
  import("pages/TaxInvoicePDI/TaxInvoicePDIRequestEdit")
);
const GatePassEntryList = React.lazy(() =>
  import("pages/GatePassEntry/GatePassEntryList")
);
const GatePassAdd = React.lazy(() => import("pages/GatePassEntry/GatePassAdd"));
const GatePassOutwardEntryAdd = React.lazy(() =>
  import("pages/GatePassEntry/GatePassOutward/GatePassOutwardEntryAdd")
);
const GatePassUpdate = React.lazy(() =>
  import("pages/GatePassEntry/GatePassUpdate")
);
const CompanyPurchaseOrderEntryAll = React.lazy(() =>
  import("pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntryAll")
);
const CompanyPurchaseOrderEntryAdd = React.lazy(() =>
  import("pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntryAdd")
);
const CompanyPurchaseOrderEntryEdit = React.lazy(() =>
  import("pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntryEdit")
);
const CompanyPurchaseOrderEntryCheck = React.lazy(() =>
  import("pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntryCheck")
);
const BomMasterDocumentAdd = React.lazy(() =>
  import("pages/BomMasterDocument/BomMasterDocumentAdd")
);
const OperationDocumentList = React.lazy(() =>
  import("pages/OperationDocument/OperationDocumentList")
);
const OperationDocumentAdd = React.lazy(() =>
  import("pages/OperationDocument/OperationDocumentAdd")
);
const CurrentStockAll = React.lazy(() =>
  import("pages/CurrentStock/CurrentStockAll")
);
const LiveStockByWareHouseList = React.lazy(() =>
  import("pages/CurrentStock/LiveStockByWareHouseList")
);
const LiveStockByWareHouseListJobWork = React.lazy(() =>
  import("pages/CurrentStock/LiveStockByWareHouseListJobWork")
);
const OperationDocumentupdate = React.lazy(() =>
  import("pages/OperationDocument/OperationDocumentupdate")
);
const BomMasterDocumentEdit = React.lazy(() =>
  import("pages/BomMasterDocument/BomMasterDocumentEdit")
);
const CompanyPurchaseOrderEntryListByCode = React.lazy(() =>
  import("pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntryListByCode")
);
const BomAcceptedManufacturedItemAdd = React.lazy(() =>
  import("pages/BomAcceptedManufacturedItem/BomAcceptedManufacturedItemAdd")
);
const CompanyShiftList = React.lazy(() =>
  import("pages/CompanySettings/CompanyShift/CompanyShiftList")
);
const CompanyShiftAdd = React.lazy(() =>
  import("pages/CompanySettings/CompanyShift/CompanyShiftAdd")
);
const WorkOrdersListForJobCard = React.lazy(() =>
  import("pages/JobCard/WorkOrdersListForJobCard")
);
const CompanyPurchaseOrderEntrycheckAll = React.lazy(() =>
  import("pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntrycheckAll")
);
const WorkOrderReturnMaterialAdd = React.lazy(() =>
  import("pages/StockTrasaction/WorkOrderMaintain/WorkOrderReturnMaterialAdd")
);
const JobCardAllInfo = React.lazy(() => import("pages/JobCard/JobCardAllInfo"));
const CompanyPurchaseOrderEntryPDIListByCode = React.lazy(() =>
  import(
    "pages/CompanyPurchaseOrderEntry/CompanyPurchaseOrderEntryPDIListByCode"
  )
);
const CustomerItemGroupItemsList = React.lazy(() =>
  import(
    "pages/CustomerDetail/CustomerItemGroup/CustomerItemGroupItems/CustomerItemGroupItemsList"
  )
);
const CustomerItemGroupItemsAdd = React.lazy(() =>
  import(
    "pages/CustomerDetail/CustomerItemGroup/CustomerItemGroupItems/CustomerItemGroupItemsAdd"
  )
);
const CustomerGroupItemEdit = React.lazy(() =>
  import("pages/CustomerDetail/CustomerItemGroup/CustomerGroupItemEdit")
);
const CustomerItemGroupCreate = React.lazy(() =>
  import("pages/CustomerDetail/CustomerItemGroup/CustomerItemGroupCreate")
);
const CompanyPurchaseOrderEntryDetailListByCode = React.lazy(() =>
  import(
    "pages/CompanyPurchaseOrderEntryDetail/CompanyPurchaseOrderEntryDetailListByCode"
  )
);
const CreditInvoiceList = React.lazy(() =>
  import("financial/pages/ChartOfAccount")
);
const GLAccountCreation = React.lazy(() =>
  import("financial/pages/GLAccountCreation")
);
const AddGL = React.lazy(() =>
  import("financial/pages/GLAccountCreation/AddGL")
);
const EditGL = React.lazy(() =>
  import("financial/pages/GLAccountCreation/EditGL")
);
const CodeSelection = React.lazy(() =>
  import("financial/pages/MasterCodeSelection/CodeSelection")
);
const DownTimeRejectionReasonsAll = React.lazy(() =>
  import("pages/DownTimeRejectionReasons/DownTimeRejectionReasonsAll")
);
const DownTimeAdd = React.lazy(() =>
  import("pages/DownTimeRejectionReasons/DownTime/DownTimeAdd")
);
const ReajectedReasonAdd = React.lazy(() =>
  import("pages/DownTimeRejectionReasons/RejectedReason/ReajectedReasonAdd")
);
const UpdateRejectedReason = React.lazy(() =>
  import("pages/DownTimeRejectionReasons/RejectedReason/UpdateRejectedReason")
);
const UpdateDownTime = React.lazy(() =>
  import("pages/DownTimeRejectionReasons/DownTime/UpdateDownTime")
);
const TestDummyData = React.lazy(() =>
  import("pages/TestDummyData/TestDummyData")
);
const StockLedgerList = React.lazy(() =>
  import("pages/StockLadger/StockLedgerList")
);
const SupplierCustomerMappingAdd = React.lazy(() =>
  import("pages/SupplierCustomerMapping/SupplierCustomerMappingAdd")
);
const JobCardProductionRejectionDetailList = React.lazy(() =>
  import(
    "pages/JobCardProductionRejectionDetail/JobCardProductionRejectionDetailList"
  )
);
const JobCardProductionRejectionDetailListAdd = React.lazy(() =>
  import(
    "pages/JobCardProductionRejectionDetail/JobCardProductionRejectionDetailListAdd"
  )
);

const ProductCostingAndProfitabilityAll = React.lazy(() =>
  import("financial/pages/Reports/ProductCostingAndProfitabilityAll")
);

const ProjectRoutes = () => {
  const status = sessionStorage.getItem("status");
  return (
    <React.Suspense
      fallback={
        <div class="flex items-center justify-center h-screen">
          <div class="relative">
            <div class="h-24 w-24 rounded-full border-t-8 border-b-8 border-gray-200"></div>
            <div class="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-blue-500 animate-spin"></div>
          </div>
        </div>
      }
    >
      <Router>
        {/* <div style={{display:'flex'}}>
      { status ?
       ( <div> 
          <Sidebar1/>
        </div> ) : (<></>)
      } */}

        <Routes>
          {/* { sessionStorage.getItem("status") ?( <Route path="/" element={<CompanyUserList />} /> ) : ( <Route path="/" element={<LogInEmpty />} />) } */}
          {/* <Route path="/" element={status ? <Sidebar1 /> : <LogInEmpty />} /> */}
          <Route
            path="/"
            element={status ? <Sidebar1 /> : <LoginPageWrapper />}
          />
          <Route path="/home" element={<Home />} />
          <Route
            path="/logout"
            // element={status ? <Logout /> : <LogInEmpty />}
            element={status ? <Logout /> : <LoginPageWrapper />}
          />
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/loginempty" element={<LogInEmpty />} /> */}
          <Route path="/loginempty" element={<LoginPageWrapper />} />
          <Route path="/otpform" element={<OTPForm />} />
          <Route path="/passwordreset" element={<PasswordResetForm />} />
          <Route path="/loginemptyone" element={<LogInEmptyOne />} />
          <Route path="/loginemptytwo" element={<LogInEmptyTwo />} />
          <Route path="/newitemdetailtwo" element={<NewItemDetailTwo />} />
          <Route path="/newitemdetail" element={<NewItemDetail />} />
          <Route path="/newitemdetailone" element={<NewItemDetailOne />} />
          <Route path="/newitemdetailthree" element={<NewItemDetailThree />} />
          <Route path="/itemListView" element={<ItemListViewPage />} />
          {/* company user */}
          <Route path="/" element={<Sidebar1 />}>
            <Route path="companyuser" element={<CompanyUser />} />
            {/* main */}
            <Route path="/companyuserlist" element={<CompanyUserList />} />
            <Route path="/updateuserlist/:id" element={<UpdateUser />} />
            <Route path="/companyUserlist/add" element={<CompanyUserAdd />} />

            <Route
              path="/companyUserAccess/:id/:name"
              element={<CompanyUserAccess />}
            />
            <Route
              path="/companyUserAccessUpdate/:userId/:id/:name"
              element={<UpdateUserAccess />}
            />
            <Route
              path="/companyUserAllAccessUpdate/:userId/:name"
              element={<UpdateUserAcessAll />}
            />
            {/* supplier  */}
            <Route path="/supplierlist" element={<SupplierList />} />
            <Route path="/supplierlist/add" element={<SupplierAdd />} />
            <Route
              path="/supplierupdate/edit/:id"
              element={<SupplierUpdate />}
            />
            <Route path="/supplierall/:id" element={<SupplierAll />} />
            {/* suppliercontact */}
            <Route
              path="/suppliercontactlist/edit/:id"
              element={<SupplierContactList />}
            />
            <Route
              path="/updatesuppliercontactlist/:id/:supplierID"
              element={<UpdateSupplierContactList />}
            />
            <Route
              path="/suppliercontact/add/:id"
              element={<SupplierContactAdd />}
            />
            {/* Supplier bank Accounts */}
            <Route
              path="/supplierbankaccount/add/:id"
              element={<SupplierBankAccountAdd />}
            />
            <Route
              path="/supplierbankaccount/edit/:id/:supplierId"
              element={<SupplierBankAccountEdit />}
            />
            {/* item supplier  */}
            <Route path="/itemsupplierlist" element={<ItemSupplierList />} />
            <Route path="/itemsupplieradd" element={<ItemSupplierAdd />} />
            <Route
              path="/itemsupplierupdate/edit/:id"
              element={<ItemSupplierUpdate />}
            />
            {/* customer  */}
            <Route path="/customer" element={<Customer />} />
            <Route path="/customerList" element={<CustomerList2 />}></Route>
            {/* customer details  */}
            <Route path="/customerdetail/:id" element={<CustomerDetails />}>
              {/* <Route path="/customerdetail/:id/contacts" element={<CustomerContact/>}></Route> */}
              {/* <Route path="/customerdetail/:id/customercontact/add/:id" element={<CustomertContactList/>}></Route> */}
            </Route>
            <Route
              path="/customerupdate/edit/:id"
              element={<CustomerUpdate />}
            />
            <Route path="/customerList/add" element={<CustomerAdd />} />
            {/* Item  */}
            <Route path="/item" element={<Item />} />
            <Route path="/individualItem/:id" element={<IndividualItem />} />
            <Route path="/itemadd" element={<AddItem />} />
            <Route path="/itemMultipleAdd" element={<ItemMultipleAdd />} />
            <Route
              path="/itemAllInformationAdd"
              element={<ItemAllInformationAdd />}
            />
            <Route path="/EditItem/edit/:id" element={<EditItem />} />
            {/* Item Inventory */}
            <Route path="itemInventory" element={<ItemInventory />} />
            <Route
              path="/addItemToInventory"
              element={<AddItemToInventory />}
            />
            <Route
              path="/updateItemToInventory/:id"
              element={<UpdateItemInventory />}
            />
            {/* customercontact */}
            {/* main  */}
            <Route path="/customerList" element={<CustomerList2 />} />
            <Route
              path="/customerupdate/edit/:id"
              element={<CustomerUpdate />}
            />
            <Route path="/customercontact" element={<CustomerContact />} />
            <Route
              path="/customercontactList/add"
              element={<CustomertContactList />}
            />
            {/* <Route path="/customercontactList/edit/:id" element={<CustomertContactList />} /> */}
            <Route
              path="/customercontact/add"
              element={<CustomerContactAdd />}
            />
            <Route
              path="/customercontactList/edit/:id"
              element={<CustomertContactList />}
            />

            <Route
              path="/customerItemGroupCreate/:id"
              element={<CustomerItemGroupCreate />}
            />
            <Route
              path="/customerItemGroupEdit/:id"
              element={<CustomerGroupItemEdit />}
            />
            <Route
              path="/customerItemGroupItemList/:cid/:id"
              element={<CustomerItemGroupItemsList />}
            />
            <Route
              path="/customerItemGroupItemAdd/:cid/:id"
              element={<CustomerItemGroupItemsAdd />}
            />

            {/* subcontractor */}
            <Route path="/subcontractor" element={<Subcontractor />} />
            <Route path="/subcontractorList" element={<SubContractorList />} />
            <Route
              path="/subcontractorlist/add"
              element={<SubcontractorAdd />}
            />
            <Route
              path="/subcontractorList/edit/:id"
              element={<SubContractorUpdate />}
            />
            {/* subcontractorcontact */}
            <Route
              path="/subcontractorcontact"
              element={<SubContractorContact />}
            />
            <Route
              path="/subcontractorcontact"
              element={<SubContractorContact />}
            />
            <Route
              path="/subcontractorcontact/add"
              element={<SubContractorContactAdd />}
            />
            <Route
              path="/SubContractorContactList/edit/:id"
              element={<SubContractorContactList />}
            />
            <Route
              path="/subcontractor/details/:id"
              element={<SubcontractorDetails />}
            />

            <Route
              path="/SubContractorContact/edit/:id"
              element={<UpDateSubContact />}
            />
            <Route
              path="/customercontactUpdate/edit/:id"
              element={<CustomertContactList />}
            />
            {/* <Route path="/suppliercontactlist/edit/:id" element={<SupplierContactList />} /> */}

            {/* <Route path="/supplierupdate/edit/:id" element={<SupplierUpdate/>} /> */}
            <Route
              path="/updatecustomercontactlist/:id"
              element={<UpdateCustomerContactList />}
            />
            <Route
              path="/updatesubcontractorcontactlist/:id"
              element={<UpdateSubcontractorContact />}
            />
            {/* <Route path="/updatesuppliercontactlist/:id" element={<UpdateSupplierContactList/>} /> */}
            {/* Item Tax */}
            <Route path="/itemtaxList" element={<ItemTaxList />} />
            <Route path="/itemtaxadd" element={<ItmTaxAdd />} />
            <Route
              path="/itemtaxupdate/edit/:id"
              element={<UpdateItemTaxList />}
            />
            {/* ItemQuality */}
            <Route path="/itemQuality" element={<ItemQualityList />} />
            <Route path="/itemQuality/add" element={<ItemQualityAdd />} />
            <Route path="/itemQuality/:id" element={<UpdateItemQuality />} />
            {/* workstation type */}
            <Route
              path="/workstationtypelist"
              element={<WorkstationTypeList />}
            />
            <Route
              path="/workstationtype/add"
              element={<WorkstationTypeAdd />}
            />
            <Route
              path="/workstationtypelist/:id"
              element={<UpdateWorkStationType />}
            />
            {/* WorkStation Working Hour  */}
            <Route
              path="/workstationworkinghour"
              element={<WorkStationHourAddList />}
            />
            <Route
              path="/workstationhourupdate/edit/:id"
              element={<UpdateWorkStationHours />}
            />
            <Route
              path="/WorkstationHour/add"
              element={<WorkStationHourAdd />}
            />
            {/* WorkStation */}
            <Route path="/workstationlist" element={<WorkStationList />} />
            <Route path="/Workstation/add" element={<WorkStationAdd />} />
            <Route
              path="/Workstation/indivisual/:id"
              element={<WorkStationIndivisual />}
            />
            <Route
              path="/workstationlist/:id"
              element={<UpdateWorkStation />}
            />
            {/* operation */}
            <Route path="/operationlist" element={<OperationList />} />
            <Route path="/operationadd" element={<OperatonAdd />} />
            <Route path="/operation/edit/:id" element={<OperationUpdate />} />
            <Route path="/operationdetails/:id" element={<OperationTab />} />

            {/* operation Document */}
            <Route
              path="/operationdocument/list/:id"
              element={<OperationDocumentList />}
            />
            <Route
              path="/operationdocument/add/:id"
              element={<OperationDocumentAdd />}
            />
            <Route
              path="/operationdocument/edit/:id/:operation_doc_id"
              element={<OperationDocumentupdate />}
            />

            {/* operation workstation */}
            <Route
              path="/operationworkstation/list"
              element={<OperationWorkstationList />}
            />
            <Route
              path="/operationworkstation/add"
              element={<OperationWorkstationAdd />}
            />
            <Route
              path="/operationworkstation/edit/:id"
              element={<OperationWorkstationUpdate />}
            />
            <Route
              path="/operation/workstation/add"
              element={<WorkStationOperationAdd />}
            />

            {/* routing */}
            <Route path="/routing/list" element={<RoutingList />} />
            <Route
              path="/routing/list/:id"
              element={<RoutingDetailListByRouting />}
            />
            <Route path="/routing/add" element={<RoutingAdd />} />
            <Route path="/routing/edit/:id" element={<RoutingUpdate />} />
            {/* routing  detail */}
            <Route path="/routingdetail/list" element={<RoutingDetailList />} />
            <Route
              path="/routingdetail/add/:id"
              element={<RoutingDetailAdd />}
            />
            <Route
              path="/routingdetail/edit/:id"
              element={<RoutingDetailUpdate />}
            />
            {/* BOM */}
            <Route path="/bom/list" element={<BomList />} />
            <Route path="/bom/add" element={<BomAdd />} />
            <Route path="/bom/edit/:id" element={<BomUpdate />} />
            <Route path="/bom/list/:id" element={<BomRawMaterialListByBom />} />
            <Route path="/bomall/:id" element={<BomAll />} />
            {/* BOM  Raw Material*/}
            <Route
              path="/bomrawmaterials/list"
              element={<BomRawMaterialList />}
            />
            <Route path="/bomrawmaterial/add" element={<BomRawMaterialAdd />} />
            <Route
              path="/bomrawmaterial/edit/:id"
              element={<BomRawMaterialUpdate />}
            />
            {/* BOM Scrap Materials */}
            <Route
              path="/bomscrapmaterial/list"
              element={<BomScrapMaterialList />}
            />
            <Route
              path="/bomscrapmaterial/add/:id"
              element={<BomScrapMaterialAdd />}
            />
            <Route
              path="/bomscapmaterial/edit/:id/:bomid"
              element={<BomScrapMaterialEdit />}
            />
            {/* BOM  Raw Material*/}
            <Route
              path="/bomrawmaterials/list"
              element={<BomRawMaterialList />}
            />
            <Route path="/bomrawmaterial/add" element={<BomRawMaterialAdd />} />
            <Route
              path="/bomrawmaterial/edit/:id"
              element={<BomRawMaterialUpdate />}
            />
            {/* Bom Master Routing */}
            <Route
              path="/bommasterrouting/list"
              element={<BomMasterRoutingList />}
            />
            <Route
              path="/bommasterrouting/add/:id"
              element={<BomMasterRoutingAdd />}
            />
            <Route
              path="/bommasterrouting/edit/:id/:bomid"
              element={<BomMasterRoutingUpdate />}
            />

            {/* BomAcceptedManufacturedItem */}
            <Route
              path="/bomacceptedmanufactureditem/add/:id"
              element={<BomAcceptedManufacturedItemAdd />}
            />

            {/* BomMaster Document Add  */}
            <Route
              path="/bommasterdocument/add/:id"
              element={<BomMasterDocumentAdd />}
            />

            <Route
              path="/bommasterdocument/edit/:id/:bomID"
              element={<BomMasterDocumentEdit />}
            />

            {/* purchase order address  */}
            <Route path="/purchaseorder/list" element={<PurchaseOrderList />} />
            <Route path="/purchaseorder/Add" element={<PurchaseOrderAdd />} />
            <Route
              path="/purchaseorderlist/:id"
              element={<PurchaseOrderUpdate />}
            />
            <Route
              path="/purchaseorderlist/view/:id"
              element={<PurchaseOrderList />}
            />
            {/* QualityInspectionTemplate */}
            <Route
              path="/qualityinspectiontemplate/list"
              element={<QualityInspectionTemplateList />}
            />
            <Route
              path="/qualityinspectiontemplate/view/:id"
              element={<QualityInspectionTemplateList />}
            />
            <Route
              path="/qualityinspectiontemplate/add"
              element={<QualityInspectionTemplateAdd />}
            />
            <Route
              path="/qualityinspectiontemplate/edit/:id"
              element={<QualityInspectionTemplateUpdate />}
            />
            {/* Sales Order */}
            <Route path="/salesorder/list" element={<SalesOrderList />} />
            <Route path="/salesorder/add/:poid" element={<SalesOrderAdd />} />
            <Route path="/salesorder/edit/:id" element={<SalesOrderEdit />} />
            <Route
              path="/salesorderall/:id/:customer_id"
              element={<SalesOrderAll />}
            />
            {/* Sales Order items */}
            <Route
              path="/salesorderitems/list"
              element={<SalesOrderItemsList />}
            />
            <Route
              path="/salesorderitems/add/:id/:customer_id"
              element={<SalesOrderItemsAdd />}
            />
            <Route
              path="/salesorder/deliverychallan/items/:id/:customer_id"
              element={<SalesOrderDeliveryChallanItemAdd />}
            />
            <Route
              path="/salesorderitems/deliverychallan/edit/:id/:salesId/:customer_id"
              element={<SalesOrderDeliveryChallanItemEdit />}
            />
            <Route
              path="/salesorderitems/edit/:id/:salesId/:customer_id"
              element={<SalesOrderItemsEdit />}
            />
            <Route
              path="/salesorderitemsbysalesorder/list/:id"
              element={<SalesOrederItemBySalesOrder />}
            />
            {/* tax invoice  */}
            <Route path="/taxinvoice/list" element={<TaxInvoiceList />} />
            <Route path="/taxinvoice/add" element={<TaxInvoiceAdd />} />
            <Route path="/taxinvoice/add/new" element={<TaxInvoiceAddNew />} />
            <Route path="/taxinvoice/edit/:id" element={<TaxInvoiceUpdate />} />
            <Route
              path="/taxinvoice/cancel/:id"
              element={<CancelTaxInvoice />}
            />
            <Route
              path="/taxinvoice/cancel/services/:id"
              element={<CancelIRNInvoice />}
            />
            <Route
              path="/taxinvoice/cancel/list"
              element={<TaxInvoiceCancelList />}
            />

            {/* tax invoice for Delivery challan */}
            {/* <Route
              path="/taxinvoice/deliverychalan/add"
              element={<AddTaxInvoiceForDeliveryChallan />}
            />
            <Route
              path="/taxinvoiceitems/deliverychalan/add/:id"
              element={<AddTaxInvoiceItemsForDeliveryChallan />}
            /> */}

            {/* Company Shift  */}
            <Route path="/companyshift/list" element={<CompanyShiftList />} />
            <Route path="/companyshift/add" element={<CompanyShiftAdd />} />

            {/* tax invoice Item */}
            <Route
              path="/taxinvoiceitem/list/:id"
              element={<TaxInvoiceItemList />}
            />
            {/* <Route path="/taxinvoiceitem/add/:id" element={<TaxInvoiceItemAdd />} /> */}
            {/* <Route
              path="/taxinvoiceitem/add/:id"
              element={<TaxInvoiceItemAddM />}
            /> */}
            <Route
              path="/taxinvoiceitem/add/:id"
              element={<TaxInvoiceAddMultiple />}
            />
            <Route
              path="/taxinvoiceitem/edit/:id"
              element={<TaxInvoiceItemUpdate />}
            />

            <Route
              path="/salesorderotherdetails/list"
              element={<SalesOrderOtherDetailsList />}
            />
            <Route
              path="/salesorderotherdetails/add/:id/:customer_id"
              element={<SalesOrderOtherDatailsAdd />}
            />
            <Route
              path="/salesorderotherdetails/edit/:id/:salesOrderOtherDetailsId/:customer_id"
              element={<SalesOrderOtherDetailsEdit />}
            />
            <Route
              path="/salesorderotherdetails/edit1/:id/:salesOrderOtherDetailsId/:customer_id"
              element={<SalesOrderOtherDetailsEdit1 />}
            />
            <Route path="/workOrder/add" element={<AddWorkOrder />} />
            <Route path="/workOrder/list" element={<WorkOrder />} />
            <Route path="/workOrder/edit/:id" element={<UpdateWorkOrder />} />
            <Route
              path="/workOrder/generateStockRequest/:id"
              element={<WorkOrderGenerateRequest />}
            />

            <Route
              path="/workOrder/StockRequest/:id"
              element={<WorkOrderMaterialRequestAll />}
            />
            <Route
              path="/workOrder/materialTransactionHistory"
              element={<WorkOrderMaterialTransactionHistory />}
            />
            <Route
              path="/workOrder/workorderitems"
              element={<WorkOrderItems />}
            />

            <Route path="invoicepdf" element={<InvoicePdf />} />
            {/* PDI Inespection  */}

            <Route
              path="/pdirequest/list"
              element={<TaxInvoicePDIRequestList />}
            />
            <Route
              path="/pdirequest/edit/:id"
              element={<TaxInvoicePDIRequestEdit />}
            />
            {/* WareHouse */}
            <Route path="/warehouse/list" element={<WareHouseList />} />
            <Route path="/warehouse/Add" element={<WareHouseAdd />} />
            <Route path="/warehouse/edit/:id" element={<WareHouseUpdate />} />
            <Route
              path="/warehouse/stocktransation/:id"
              element={<WareHouseAll />}
            />

            {/* quality inspection */}
            <Route
              path="/inwardqualitycontrol/list"
              element={<QualityTopTab />}
            />
            {/* Stock Transaction */}
            <Route
              path="/stocktransaction/purchaselist"
              element={<StocktransactionAll />}
            />
            <Route
              path="/stocktransaction/purchase/add"
              element={<StockPurchaseAdd />}
            />
            <Route
              path="/purchasetransactionhistory/:po_wo_inv_other_id"
              element={<PurchaseAll />}
            />
            <Route
              path="/jobworktransactionhistory/:po_wo_inv_other_id"
              element={<JobWorkInwardAll />}
            />
            <Route
              path="/stocktransaction/purchase/update/:id"
              element={<StockPurchaseUpdate />}
            />
            {/* WorkOrder Maintain  */}
            <Route
              path="/workorderstockmaintain/all/:id"
              element={<WorkOrderMaintainAll />}
            />
            <Route
              path="/workorderstockreqissue/add/:id"
              element={<WorkOrderMaintainIssueAdd />}
            />

            <Route
              path="/workorderstockreqreturn/add/:id"
              element={<WorkOrderReturnMaterialAdd />}
            />
            {/* Delivery challan Inward */}
            <Route
              path="/deliverychallaninward/add"
              element={<DeliveryChallanInwardAdd />}
            />
            <Route
              path="/jobworkinwardlist/add"
              element={<JobWorkInwardtoStore />}
            />
            <Route path="/stockledger" element={<StockLedgerList />} />
            <Route
              path="/suppliercustomermappingadd/add/:id"
              element={<SupplierCustomerMappingAdd />}
            />
            <Route
              path="/JobCardProductionRejectionDetailList"
              element={<JobCardProductionRejectionDetailList />}
            />
            {/* <Route
              path="/jobcard/rejectionitem/add"
              element={<JobCardProductionRejectionDetailListAdd />}
            /> */}
            <Route
              path="/jobcard/rejectionitem/add"
              element={<JobCardProductionRejectionDeailsTopTab />}
            />
            <Route
              path="/report/product/costing"
              element={<ProductCostingAndProfitabilityAll />}
            />

            <Route
              path="/deliverychallaninward/list"
              element={<DeliveryChallanInwardTransactionList />}
            />

            <Route
              path="/deliverychallaninward/all/:id"
              element={<DeliveyChallanInwardAll />}
            />

            {/* Delivary Challan  */}

            <Route
              path="/delivarychallan/list"
              element={<DelivaryChallanList />}
            />

            <Route
              path="/delivarychallan/add"
              element={<DelivaryChallanAdd />}
            />

            <Route
              path="/delivarychallan/edit/:id"
              element={<DeliveryChallanEdit />}
            />
            <Route
              path="/delivarychallan/cancel/:id"
              element={<DeliveryChallanEwayBillCancel />}
            />

            {/* Delivery challan Item */}

            <Route
              path="/delivarychallanitem/list/:id/:delivery_challan_type_id/:customer_id"
              element={<DeliveryChallanItemList />}
            />

            <Route
              path="/delivarychallanitem/add/:id/:delivery_challan_type_id/:customer_id"
              element={<DeliveryChallanItemAdd />}
            />
            <Route
              path="/delivarychallanitem/jobwork/add/:id/:delivery_challan_type_id/:customer_id"
              element={<DeliveryChallanItemJobWork />}
            />
            <Route
              path="/delivarychallanitem/edit/:id/:dcID/:delivery_challan_type_id"
              element={<DeliveryChallanItemUpdate />}
            />

            {/* Current STock */}
            <Route path="/currentStock" element={<CurrentStockAll />} />
            <Route
              path="/currentStock/warehouse/:id"
              element={<LiveStockByWareHouseList />}
            />
            <Route
              path="/currentStock/warehouse/jobwork/:id"
              element={<LiveStockByWareHouseListJobWork />}
            />

            {/* Job Card */}
            <Route
              path="/WorkOrderListjobcard/list"
              element={<WorkOrdersListForJobCard />}
            />
            <Route path="/jobcard/list" element={<JobCardList />} />
            <Route path="/jobcard/update/:id" element={<JobCardUpdate />} />
            <Route path="/jobcard/all/:id" element={<JobCardAll />} />
            <Route path="/jobcard/addAll/:id" element={<JobCardAllInfo />} />
            <Route
              path="/jobcard/individual/:id"
              element={<JobCardIndividual />}
            />
            <Route path="/jobcard/add/new" element={<JobCardAddNew />} />
            {/* Job Card work*/}
            <Route path="/jobcardwork/list/:id" element={<JobCardWork />} />
            <Route
              path="/jobcardwork/add/:id"
              element={<JobCardWorkCreate />}
            />
            <Route
              path="/jobcardProduction/add/:id"
              element={<CreateJobCardProduction />}
            />
            <Route
              path="/jobcardProduction/update/:id/:pid"
              element={<JobCardProductionUpdate />}
            />
            <Route
              path="/jobcardDowntim/add/:id"
              element={<CreateJobCardDowntime />}
            />

            <Route path="/HsnSac/all" element={<HsnSacAll />} />
            <Route path="/Hsn/add" element={<HsnCreate />} />
            <Route path="/Sac/add" element={<SacCreate />} />
            <Route path="/Hsn/update/:id" element={<HsnUpdate />} />
            <Route path="/Sac/update/:id" element={<SacUpdate />} />

            {/* Capacity Plan */}
            <Route path="/CapacityPlan/list" element={<CapacityPlanList />} />
            <Route path="/CapacityPlan/add" element={<CapacityPlanAdd />} />
            <Route
              path="/CapacityPlan/update/:id"
              element={<UpdateCapacityPlan />}
            />
            <Route
              path="/CapacityPlan/indvidual/:id"
              element={<IndividualCapacityPlan />}
            />
            <Route
              path="/CapacityPlanItem/add/:id"
              element={<CapavityPlanItemAdd />}
            />
            <Route
              path="/CapacityPlanItem/update/:id"
              element={<CapacityItemUpdate />}
            />
            {/* customer bank account  */}
            <Route
              path="/customerbankacc/list"
              element={<CustomerBankAccountList />}
            />
            <Route
              path="/customerbankacc/add"
              element={<CustomerBankAccountAdd />}
            />
            <Route
              path="/customerbankacc/edit/:id"
              element={<CustomerBankAccountUpdate />}
            />

            {/* sales */}
            <Route
              path="/salestransactionhistory/:po_wo_inv_other_id"
              element={<SalesAll />}
            />

            {/* Adustment  */}
            <Route path="/adjustment/add" element={<AdjustmentAdd />} />

            {/* Manufacture */}
            <Route path="/manufacture/all/:id" element={<ManufactureAll />} />
            <Route
              path="/stocktransaction/manufacture/add"
              element={<ManufactureAdd />}
            />

            {/* Item Customer */}
            <Route path="/itemcustomerlist" element={<ItemCustomerList />} />
            <Route path="/itemcustomer/add" element={<ItemCustomerAdd />} />
            <Route
              path="/itemcustomer/edit/:id"
              element={<ItemCustomerEdit />}
            />
            {/* EwayBill */}
            <Route path="/create/ewaybill/login" element={<LoginEwayBill />} />
            <Route path="/ewaybill/login" element={<EwayBillLoginList />} />

            {/* CompanyPurchesOrde */}
            <Route
              path="/companypurchesorder/list"
              element={<CompanyPurchesOrderList />}
            />
            <Route
              path="/companypurchesorder/add"
              element={<CompanyPurchesOrderAdd />}
            />
            <Route
              path="/companypurchesorder/edit/:id"
              element={<CompanyPurchaseOrderEdit />}
            />
            <Route
              path="/companypurchesorder/all/:poid/:supplier_id"
              element={<CompanyPurchaseOrderAll />}
            />

            {/* GatePass Entry */}
            <Route path="/gatepassentry/all" element={<GatePassTopTab />} />
            <Route path="/gatepassentry/add" element={<GatePassAdd />} />
            <Route
              path="/gatepassentry/outward/add"
              element={<GatePassOutwardEntryAdd />}
            />
            <Route
              path="/gatepassentry/update/:id"
              element={<GatePassUpdate />}
            />

            {/* Company Purches Orde Entry */}
            <Route
              path="/companypurchesorderentry/all"
              element={<CompanyPurchaseOrderEntryAll />}
            />
            <Route
              path="/companypurchesorderentry/add"
              element={<CompanyPurchaseOrderEntryAdd />}
            />
            <Route
              path="/companypurchesorderentry/edit/:company_purchase_order_id/:id"
              element={<CompanyPurchaseOrderEntryEdit />}
            />
            <Route
              path="/companypurchesorderentry/edit/check/:company_purchase_order_id/:id"
              element={<CompanyPurchaseOrderEntryCheck />}
            />
            <Route
              path="/companypurchesorderentry/edit/check/all/:company_purchase_order_id/"
              element={<CompanyPurchaseOrderEntrycheckAll />}
            />
            <Route
              path="/companypurchesorderentry/view/:company_purchase_order_id"
              element={<CompanyPurchaseOrderEntryListByCode />}
            />
            <Route
              path="/companypurchesorderentryPDI/view/:company_purchase_order_id"
              element={<CompanyPurchaseOrderEntryPDIListByCode />}
            />
            {/* Company Purches Orde Entry Details*/}

            <Route
              path="/companypurchesorderentry/rejected/view/:company_purchase_order_id"
              element={<CompanyPurchaseOrderEntryDetailListByCode />}
            />
            {/* Transport */}
            <Route path="/transporter/add" element={<TransporterAdd />} />
            <Route path="/transporterlist" element={<TransporterList />} />
            <Route path="/transporter/edit/:id" element={<TransporterEdit />} />
            <Route
              path="/transport/view/:id"
              element={<TransporterDetailsAll />}
            />
            {/* Transporter Bank Account */}

            <Route
              path="/transportbankaccount/add"
              element={<TransporterBankAccountsAdd />}
            />

            <Route
              path="/transportbankaccount/edit/:id"
              element={<TransporterBankAccountsEdit />}
            />
            {/* EwayBillGenerate */}

            <Route
              path="/ewaybill/generate/:id"
              element={<EwayBillGenerate />}
            />
            {/* EwayBillGenerate */}

            <Route
              path="/deliverychallanewaybill/generate/:id"
              element={<DeliveryChallanEwayBill />}
            />

            {/* Company Bank Account  */}
            <Route
              path="/companysettingsall"
              element={<CompanySettingsAll />}
            />

            <Route
              path="/companybankaccount/add"
              element={<CompanyBankAccountAdd />}
            />

            <Route
              path="/companybankaccount/edit/:id"
              element={<CompanyBankAccountEdit />}
            />

            {/* Company Ledger  */}

            <Route path="/companyledger/add" element={<CompanyLedgerAdd />} />
            <Route
              path="/companyledger/edit/:id"
              element={<CompanyLedgerEdit />}
            />

            {/* SUBCONTRACTOR bank account  */}
            <Route
              path="/subcontractorbankacc/add"
              element={<SubcontractorBankAccountAdd />}
            />
            <Route
              path="/subcontractbankacc/edit/:id"
              element={<UpdateSubcontractorBankAccount />}
            />

            {/* company purchase order items */}
            <Route
              path="/companypurchesorderitems/list"
              element={<CompanyPurchaseOrderitemList />}
            />

            <Route
              path="/companypurchesorderitems/add/:poid/:supplier_id"
              element={<CompanyPurchaseOrderItemAdd />}
            />
            <Route
              path="/companypurchesorderrejecteditems/edit/:poid/:supplier_id/:id"
              element={<CompanyPurchaseOrderRejectedItemsEdit />}
            />
            {/* <Route
              path="/companypurchesorderitems/edit/:id/:poid"
              element={<CompanyPurchaseOrderItemEdit />}
            /> */}
            <Route
              path="/companypurchesorderitems/edit/:id/:poid/:supplier_id"
              element={<CompanyPurchaseOrderItemRevise />}
            />
            <Route
              path="/companypurchesorderitemsrevision/list/:poid"
              element={<CompanyPurchaseOrderItemRevise />}
            />

            {/* CreditNote & DebitNote */}
            <Route
              path="/creditdebitnoteAll"
              element={<CreditDebitNoteAll />}
            />
            <Route path="/creditNote/add" element={<CreditNoteAdd />} />
            <Route
              path="/creditNote/item/:id"
              element={<CreditNoteItemList />}
            />
            <Route
              path="/creditNote/item/add/:id"
              element={<CreditNoteItemsAdd />}
            />

            <Route
              path="/creditnote/cancel/einvoice/:id"
              element={<CreditNoteCancel />}
            />

            {/* Debit Note  */}
            <Route path="/DebitNoteAll" element={<DebitNoteTab />} />
            <Route path="/debitNote/add" element={<DebitNoteAdd />} />
            <Route path="/debitnote/item/:id" element={<DebitNoteItemList />} />
            <Route
              path="/debitnote/item/add/:id"
              element={<DebitNoteItemsAdd />}
            />

            {/* DashBoard */}
            <Route path="/dashboard" element={<DashBoard />} />

            <Route path="/dashboardall" element={<DashBoardAll />} />

            <Route path="/dashboardtest" element={<Dashboardtest />} />

            <Route path="/dashboardtestall" element={<DashBoardTestAll />} />

            <Route path="/dashboarditems" element={<DashBoardItems />} />

            <Route path="/supplierpo/all" element={<SupplierPoAll />} />

            <Route path="/dashboardnewtest" element={<DashBoardNewTest />} />

            <Route
              path="/dashborditemwiserevenuereport"
              element={<DashbordItemWiseRevenueReport />}
            />

            <Route
              path="/taxinvoiceagainstsalesorder"
              element={<TaxInvoiceAgaistSalesOrderReport />}
            />

            <Route
              path="/supplierAllInfo/add"
              element={<SupplierAllInfoAdd />}
            />

            <Route
              path="/salesorderreport/all"
              element={<SalesOrderReportAll />}
            />

            <Route path="/jobcardreport/all" element={<JobCardReportAll />} />

            <Route
              path="/iteminventoryreorts/all"
              element={<ItemInventoryReportAll />}
            />

            {/* supplier Report Dashboard.... */}
            <Route
              path="/dashboardsupplierReportAll"
              element={<DashBoardSupplierReportAll />}
            />
            <Route path="/report/jobwork" element={<JobWorkReports />} />

            <Route
              path="/itemwisesupplierrevenuereport"
              element={<ItemWiseSupplierReport />}
            />

            <Route
              path="/categorywisesuppliersalesreport"
              element={<CategoryWiseSupplierSalesReport />}
            />

            {/* Waiting for inward */}
            <Route
              path="/waitingforinwardadd/:company_purchase_order_id"
              element={<WaitingforInwardAdd />}
            />
            <Route
              path="/waitingforinwardjobworkadd/:company_purchase_order_id"
              element={<WaitingForInwardJobWork />}
            />

            {/* customer address  */}
            <Route
              path="/customeraddress/list"
              element={<CustomerAddressList />}
            />
            <Route
              path="/customeraddress/add/:id"
              element={<CustomerAddressAdd />}
            />
            <Route
              path="/customeraddress/edit/:id"
              element={<CustomerAddressupdate />}
            />

            {/* company address */}

            <Route path="/companyaddress/add" element={<CompanyAddressAdd />} />

            <Route
              path="/companyaddress/edit/:id"
              element={<CompanyAddressEdit />}
            />

            {/* DownTime and Rejected Reason */}
            <Route
              path="/downtimerejectionreasonsall"
              element={<DownTimeRejectionReasonsAll />}
            />
            <Route path="/downtime/add" element={<DownTimeAdd />} />
            <Route
              path="/rejectedreason/add"
              element={<ReajectedReasonAdd />}
            />
            <Route
              path="/rejectedreason/edit/:id"
              element={<UpdateRejectedReason />}
            />
            <Route path="/downtime/edit/:id" element={<UpdateDownTime />} />

            <Route path="/glcreation" element={<GLAccountCreation />} />
            <Route path="/chartofaccount/*" element={<CreditInvoiceList />} />

            <Route path="/addledger" element={<AddLedger />} />
            <Route path="/findepartment" element={<CompanyDepartment />} />

            <Route path="/editdepartment" element={<EditDepartment />} />
            <Route path="/adddepartment" element={<AddDepartment />} />
            <Route path="/profitcenter" element={<ProfitCenter />} />
            <Route path="/addprofitcenter" element={<AddProfitCenter />} />
            <Route path="/editprofitcenter" element={<EditProfitCenter />} />

            <Route path="/costcenter" element={<CostCenter />} />
            <Route path="/addgl" element={<AddGL />} />
            <Route path="/editgl" element={<EditGL />} />
            <Route path="/editledger" element={<EditLedger />} />

            <Route path="/codeselection" element={<CodeSelection />} />

            <Route path="/ledgers" element={<CompanyLedgers />} />

            {/* cop invoice booking routes */}
            <Route
              path="/purchase-invoice-booking"
              element={<FinCompanyPurchaseOrderList />}
            />

            <Route
              path="/purchase-invoice-booking/add"
              element={<FinCompanyPurchaseOrderInvoiceAddModal />}
            />

            <Route path="/testdummydata/getAll" element={<TestDummyData />} />
          </Route>
          {/* {Comapny Account} */}
        </Routes>

        {/* </div> */}
      </Router>
    </React.Suspense>
  );
};
export default ProjectRoutes;
